<footer style="background-color: #f2f2f3; padding: 20px 10px; color: #333; box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.1);">

  <div class="footer-container">
    <!-- Left Section -->
    <div class="footer-left">
      <div class="contact-item">
        <mat-icon class="material-symbols-outlined">location_on</mat-icon>
        Awfis Oyster Complex, Somajiguda, Begumpet
      </div>
      <div class="contact-item">
        <mat-icon class="material-symbols-outlined">mail</mat-icon>
        <a href="mailto:support@sharkify.ai" style="color: #333;">support@sharkify.ai</a>
      </div>
      <div class="contact-item">
        <mat-icon class="material-symbols-outlined">call</mat-icon> +91 8712228651 , +91 7075451542
      </div>
      <div class="social-icons">
        <a href="https://www.linkedin.com/company/sharkify/" target="_blank">
          <img src="assets/contact_us/in.png" alt="LinkedIn" height="25">
        </a>
        <a href="https://www.instagram.com/sharkify.ai" target="_blank">
          <img src="assets/contact_us/insta.png" alt="Instagram" height="30">
        </a>
        <a href="https://www.facebook.com/share/153Q2sMeGv/" target="_blank">
          <img src="assets/contact_us/facebook.png" alt="Facebook" height="25">
        </a>
        <a href="#" target="_blank">
          <img src="assets/contact_us/TW.png" alt="Twitter" height="25">
        </a>
        <a href="#" target="_blank">
          <img src="assets/contact_us/yt.png" alt="YouTube" height="25">
        </a>
      </div>
    </div>
    <!-- Right Section -->
    <div class="footer-right">
      <div class="footer-column">
        <h4>Explore</h4>
        <ul>
          <li style="cursor: pointer;">
            <a style="text-decoration: none;" routerLink="/Home" (click)="scrollTo('HomeSection')"><img src="\assets\footer.png" alt="Home"
              style="width:10px;height:10px;margin-right: 5px;">Home</a>
          </li>
          <li style="cursor: pointer;">
            <a style="text-decoration: none;" routerLink="/Home" (click)="scrollTo('ExpertsIn')"><img src="\assets\footer.png" alt="Experts"
              style="width:10px;height:10px;margin-right: 5px;">Experts In</a>
          </li>
          <li style="cursor: pointer;">
            <a style="text-decoration: none;" routerLink="/Home" (click)="scrollTo('Tools')"><img src="\assets\footer.png" alt="Experts"
              style="width:10px;height:10px;margin-right: 5px;">Sharkify Tools</a>
          </li>
          <li style="cursor: pointer;">
            <a style="text-decoration: none;" routerLink="/ContactUs"><img src="\assets\footer.png" alt="Contact"
              style="width:10px;height:10px;margin-right: 5px;">Contact Us</a>
          </li>
        </ul>
      </div>
      <div class="footer-column">
        <h4>Our Services</h4>
        <ul>
          <li><a routerLink="/digital-marketing"><img src="\assets\footer.png" alt="Digital"
            style="width:10px;height:10px;margin-right: 5px;">Digital Marketing</a></li>
          <li><a routerLink="/UI-UX"><img src="\assets\footer.png" alt="UIUX"
            style="width:10px;height:10px;margin-right: 5px;">UI/UX Design</a></li>
          <li><a routerLink="/graphic-editing"><img src="\assets\footer.png" alt="Graphic"
            style="width:10px;height:10px;margin-right: 5px;">Graphic Design</a></li>
          <li><a routerLink="/video-editing"><img src="\assets\footer.png" alt="Video"
            style="width:10px;height:10px;margin-right: 5px;">Video Editing</a></li>
          <li><a routerLink="/website-development"><img src="\assets\footer.png" alt="Web"
            style="width:10px;height:10px;margin-right: 5px;">Web Designing</a></li>
          <li><a routerLink="/seo"><img src="\assets\footer.png" alt="SEO"
            style="width:10px;height:10px;margin-right: 5px;">SEO & Content Writing</a></li>
        </ul>        
      </div>
      <div class="footer-column">
        <h4>Legal</h4>
        <ul>
          <li><a routerLink="/TermsAndConditions"><img src="\assets\footer.png" alt="Terms"
            style="width:10px;height:10px;margin-right: 5px;">Terms & Conditions</a></li>
          <li><a routerLink="/PrivacyPolicy"><img src="\assets\footer.png" alt="Privacy"
            style="width:10px;height:10px;margin-right: 5px;">Privacy Policy</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="footer-bottom" style="text-align: center;">
    © Copyright by Sharkify.ai
  </div>
</footer>
